<template>
  <div
    class="flex_box"
    :style="styleMerge"
  >
    <div class="current-active" />
    <div
      v-if="viewData.title"
      class="component-header"
    >
      <div
        class="component-title"
        :style="itemStyleMerge"
        :class="viewData.required ? 'required' : ''"
      >
        <div>{{ viewData.title }}</div>
        <div class="subtitle">
          {{ viewData.subtitle }}
        </div>
      </div>
      <div class="">
        <div class="three-dot" />
      </div>
    </div>
    <el-date-picker
      v-model="date"
      type="date"
      :placeholder="viewData.placeholder"
      style="width: 100%"
      disabled
    />
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpSelectDate',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      viewData: {},
      date: ''
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
